/*
	The shared geekgroup session cookie. Identical scheme to the main app and
	Tally: a 32-char `token` on `.geekgroup.app`, so a user already signed in to
	geekgroup (or Tally) sails through consent without logging in again. On
	localhost the cookie is host-only (dev just logs in each time).
*/
export default {

	// the current geekgroup token, if any
	geekgroup: function() {

		var match = document.cookie.match(/(?:^|;\s*)token=([a-z0-9]{32})/i)

		return match ? match[1] : false

	},

	// shared cookie domain on *.geekgroup.app; host-only elsewhere
	domain: function() {

		return /(?:^|\.)geekgroup\.app$/.test(window.location.hostname) ? '; domain=.geekgroup.app' : ''

	},

	set: function(token) {

		document.cookie = 'token=' + token + '; path=/' + this.domain() + '; max-age=' + (60 * 60 * 24 * 365)

	},

	clear: function() {

		document.cookie = 'token=; path=/' + this.domain() + '; max-age=0'

	}

}
